import { render, staticRenderFns } from "./filtros.vue?vue&type=template&id=84dffd08&scoped=true&"
import script from "./filtros.vue?vue&type=script&lang=js&"
export * from "./filtros.vue?vue&type=script&lang=js&"
import style0 from "./filtros.vue?vue&type=style&index=0&id=84dffd08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dffd08",
  null
  
)

export default component.exports